<template>
  <div class="column padding-top">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-right-top"
      icon="arrow-download"
      :disabled="!transactionSummaryReport"
      @click="downloadReport"
    >
      {{ $t('FLOW.DOWNLOAD_REPORT') }}
    </woot-button>
    <report-filter-selector
      v-if="filterItemsList"
      :filter-items-list="filterItemsList"
      :hide-groupby="false"
      @date-range-change="onDateRangeChange"
    />

    <div class="row">
      <div class="report-bar" style="width:100%;">
        <div class="row">
          <div class="column">
            <TransactionSummaryTable
              :is-loading="isFetching"
              :data="transactionSummaryReport"
            ></TransactionSummaryTable>
            <!-- <div class="loadMore_btn">
              <woot-button
                variant="clear"
                size="small"
                color-scheme="primary"
                :is-loading="isFetching"
                :is-disabled="paginationCompute.isLastPage"
                @click="onPageChange(Number(meta.current_page)+1)"
              >
                {{paginationCompute.btnText}}
              </woot-button>
            </div> -->

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import TransactionSummaryTable from "./TransactionSummaryTable.vue"
import ReportFilterSelector from '../components/FilterSelector';
import format from 'date-fns/format';


export default {
    name:"TransactionSummary",
    components:{
        TransactionSummaryTable,
        ReportFilterSelector,
    },
    data(){
        const {start_date,end_date} = this.getLast7Days();
        return {
            // store dates
            start_date,
            end_date,
        }
    },
    computed:{
        ...mapGetters({
            isFetching: 'getIsFetchingUsageReport',
            //   meta: "getExpireCredit_meta",
            // meta: "getMeetingUsage_meta",
            transactionSummaryReport: "getTransactionSummaryReport",
        }),
        filterItemsList() {
            return this.$store.getters['inboxes/getInboxes'] || [];
        },
    },
    mounted(){
        // this.$store.dispatch('fetchExpiredCreditReport',this.getLast7Days())
        // this.onPageChange(1);
    },
    methods:{
        onPageChange(current_page=1,){
            this.$store.dispatch('fetchTransactionSummaryReport',{
                // current_page,
                start_date: this.start_date,
                end_date: this.end_date,
            })
        },
        onDateRangeChange({ from, to }) {
            const fromDate = format(new Date(from * 1000), 'yyyy-MM-dd');
            const toDate = format(new Date(to * 1000), 'yyyy-MM-dd');
                this.start_date = fromDate;
                this.end_date = toDate;
                this.$nextTick(()=>{
                this.onPageChange(); // this.meta.current_page   // no need page here
            });
        },
        getLast7Days() {
            const today = new Date();
            const end_date = today.toISOString().split('T')[0];
            const start_date = new Date(today);
            start_date.setDate(today.getDate() - 7);
            const start_date_str = start_date.toISOString().split('T')[0];

            return {
                start_date: start_date_str,
                end_date: end_date
            };
        },
        downloadReport() {
          const dataObj = this.transactionSummaryReport;
          const filename = 'transaction_summary.csv';

          if (!dataObj || typeof dataObj !== 'object' || Object.keys(dataObj).length === 0) {
            console.error("No data available to download.");
            return;
          }

          // Convert object to array of { activity, value }
          const dataArray = Object.entries(dataObj).map(([activity, value]) => ({
            activity,
            value
          }));

          // Extract headers manually
          const headers = ['activity', 'value'];

          // Convert to CSV
          const csvData = [
            headers.join(','), // headers
            ...dataArray.map(row =>
              headers.map(field => JSON.stringify(row[field])).join(',')
            )
          ].join('\r\n');

          // Create and trigger download
          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);

          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        // end method
    },
}
</script>




<style lang="scss" scoped>
.padding-top {
  padding-top: 1.6rem;
}
.report-bar {
  padding: 1.6rem;
}
// .csat--metrics-container {
//   background: var(--white);
//   margin-bottom: var(--space-two);
//   border-radius: var(--border-radius-normal);
//   border: 1px solid var(--color-border);
//   padding: var(--space-normal);
// }
// .loadMore_btn button{
//   display: block;
//   margin: auto;
// }
</style>
